const docToQuizFeedbacks = ['Generate more', 'Funnier', 'Easier', 'Harder', 'More question types']
const aiSlidesGeneratorFeedbacks = ['Generate more', 'Funnier', 'Easier', 'Harder']

// AI SLIDES GENERATOR
const AI_ROLE_USER = 'USER'
const AI_ROLE_SYSTEM = 'SYSTEM'
const AI_SYSTEM_GREETINGS_MESSAGE_TYPE = 'greetings'
const AI_SYSTEM_PENDING_MESSAGE_TYPE = 'generating-slide'
const AI_SYSTEM_ADDED_SLIDE_MESSAGE_TYPE = 'added-slide'
const AI_SYSTEM_ERROR_MESSAGE_TYPE = 'system-error'
const AI_SYSTEM_SUCCESS_MESSAGE_TYPE = 'generate-successful'
const AI_USER_DOC_TO_SLIDE_MESSAGE_TYPE = 'generate-from-doc'

export default {
  docToQuizFeedbacks,
  aiSlidesGeneratorFeedbacks,

  // AI SLIDES GENERATOR
  AI_ROLE_USER,
  AI_ROLE_SYSTEM,
  AI_SYSTEM_GREETINGS_MESSAGE_TYPE,
  AI_SYSTEM_PENDING_MESSAGE_TYPE,
  AI_SYSTEM_ADDED_SLIDE_MESSAGE_TYPE,
  AI_SYSTEM_ERROR_MESSAGE_TYPE,
  AI_SYSTEM_SUCCESS_MESSAGE_TYPE,
  AI_USER_DOC_TO_SLIDE_MESSAGE_TYPE,
}
